import { Skeleton } from "@/components/ui/skeleton";

// Same blocks as BrandProfilePage: the header card (logo, name, site, one-line positioning), then three rows of two
// profile cards. Cards keep the real chrome (white, bordered, p-5) with skeleton lines inside, so only the content
// changes when the data arrives. It stands in for the page while its code and data load. Keep it in step with the page.
const ProfileCardSkeleton = ({ lines }: { lines: number[] }) => (
  <div className="rounded-2xl border border-border bg-card p-5">
    <Skeleton className="h-4 w-28" />
    <div className="mt-3 space-y-2.5">
      {lines.map((w, i) => <Skeleton key={i} className="h-4" style={{ width: `${w}%` }} />)}
    </div>
  </div>
);

const BrandProfileSkeleton = () => (
  <main className="pb-6 pt-12" aria-busy="true" aria-label="Loading">
    <div className="ernest-container space-y-6">
      <section className="rounded-2xl border border-border bg-card p-6">
        <div className="flex items-start gap-6">
          <Skeleton className="h-[84px] w-[84px] shrink-0 rounded-lg" />
          <div className="min-w-0 flex-1">
            <div className="flex flex-wrap items-center gap-x-5 gap-y-1">
              <Skeleton className="h-[30px] w-56" />
              <Skeleton className="h-4 w-32" />
            </div>
            <Skeleton className="mt-3 h-4 w-full max-w-xl" />
            <Skeleton className="mt-2 h-4 w-2/3 max-w-md" />
          </div>
        </div>
      </section>
      {[[[90, 70, 55], [100, 100, 100]], [[100, 85, 60], [90, 65]], [[100, 100], [95, 70]]].map((row, i) => (
        <section key={i} className="grid grid-cols-1 gap-4 md:grid-cols-2">
          {row.map((lines, j) => <ProfileCardSkeleton key={j} lines={lines} />)}
        </section>
      ))}
    </div>
  </main>
);

export default BrandProfileSkeleton;
